import './AddLinkDialog.scss'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import DialogButton from '../DialogButton/DialogButton'
import CloseModalButton from '../CloseModalButton'
import TextField from './AddLinkDialogTextField'
import { withStyles } from '@material-ui/core/styles'

export const URL_MAX_LENGTH = 2083
export const NAME_MAX_LENGTH = 150

const defaultState = {
  url: '',
  name: ''
}

const titleStyles = (theme) => ({
  root: {
    paddingBottom: '16px',
    width: '480px'
  }
})

export const AddLinkDialogTitle = withStyles(titleStyles)(DialogTitle)

class AddLinkDialog extends PureComponent {
  constructor(props) {
    super(props)
    this.state = defaultState
  }

  canSave = () => {
    return !!this.state.url.trim()
      && this.state.url.length <= URL_MAX_LENGTH
      && this.state.name.length <= NAME_MAX_LENGTH
  }

  close = () => {
    this.props.closeModal()
    this.reset()
  }

  reset = () => {
    this.setState(defaultState)
  }

  saveLink = () => {
    this.props.addLink(this.state.url, this.state.name)
    this.close()
  }

  render() {
    const { localize } = this.props
    return (
      <Dialog
        open={this.props.open}
        className={'add-link-dialog'}
        onClose={this.close} >
        <AddLinkDialogTitle>
          <div className={'add-link-dialog__title'}>
            {localize('taskBoards.Label_AttachTaskLink')}<CloseModalButton onClose={this.close} />
          </div>
        </AddLinkDialogTitle>
        <DialogContent>
          <div className={'add-link-dialog__content'}>
            <TextField
              autoFocus
              className={'add-link-dialog__text-field'}
              onChange={event => { this.setState({ url: event.target.value }) }}
              value={this.state.url}
              label={localize('taskBoards.Label_TaskLinkUrl')}
              helperText={this.state.url.length > URL_MAX_LENGTH
                ? localize('taskBoards.Msg_TaskLinkUrlLengthError').replace('{urlMaxLength}', URL_MAX_LENGTH)
                : ' '}
              error={this.state.url.length > URL_MAX_LENGTH}
              margin='normal'
              fullWidth />
            <TextField
              className={'add-link-dialog__text-field add-link-dialog__text-field--last'}
              onChange={event => { this.setState({ name: event.target.value }) }}
              value={this.state.name}
              label={localize('taskBoards.Label_TaskLinkName')}
              helperText={this.state.name.length > NAME_MAX_LENGTH
                ? localize('taskBoards.Msg_TaskLinkNameLengthError').replace('{nameMaxLength}', NAME_MAX_LENGTH)
                : ' '}
              error={this.state.name.length > NAME_MAX_LENGTH}
              margin='normal'
              fullWidth />
          </div>
        </DialogContent>
        <DialogActions>
          <div className={'add-link-dialog__actions'}>
            <DialogButton
              color='primary'
              onClick={this.close}
              disableRipple
              disableFocusRipple >
              { localize('common.Button_Cancel') }
            </DialogButton>
            <DialogButton
              disabled={!this.canSave()}
              color='primary'
              onClick={this.saveLink}
              disableRipple
              disableFocusRipple >
              { localize('common.Button_Save') }
            </DialogButton>
          </div>
        </DialogActions>
      </Dialog>
    )
  }
}

AddLinkDialog.propTypes = {
  addLink: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  open: PropTypes.bool,
  task: PropTypes.object.isRequired,
  localize: PropTypes.func.isRequired
}

export default AddLinkDialog



// WEBPACK FOOTER //
// ./src/components/AddLinkDialog/AddLinkDialog.js